$('.ttgNCETextWeiterlesenLink').click(function(e) {
    e.preventDefault();
    $(this).hide();
    $(this).next().slideToggle("slow");
});